import Service from "../../services";

const hospitalModule = {
  namespaced: true,
  state: {
    message: "Vue.js Advance Boilerplate",
    latestCreatedId: null,
    list: [],
    filter: [],
    data: {
      id: "",
      name: "",
      branch: "",
      address: "",
      road: "",
      phone: "",
      corporation: null,
      office_phone: "",
      district_code: "",
      districts_name: "",
      sub_district_code: "",
      sub_districts_name: "",
      province_code: "",
      province_name: "",
      postal_code: "",
      email: "",
      fax: "",
      line_id: "",
      note: "",
      contact_types: [],
      contact_types_detail: [],
      tax_id: "",
      direction_info: { direction: null, morning: null, afternoon: null },
      billing_name: "",
      credit_type_id: "",
      customer_type_id: "",
      urgency_hospital_type_id: "",
      credit_type: null,
      customer_type: null,
      urgency_hospital_type: null,
      // corporation_id: '',
      addresses: [],
      phones: [],
      lineIds: [],
      faxs: [],
      emails: [],
      animals: [],
      created_by: null,
      updated_by: null,
      created_at: null,
    },
    filters: {
      page_no: "1",
      direction: null,
      name: "",
      dateOne: "",
      dateTwo: "",
    },
  },
  mutations: {
    GET_ALL_HOSPITALS: (state, data) => {
      state.list = data;
    },
    FILTER_HOSPITALS: (state, data) => {
      state.filter = data;
    },
    SET_LATEST_CREATED_ID: (state, data) => {
      state.latestCreatedId = data;
    },
    SET_DATA: (state, data) => {
      state.data.id = data.id;
      state.data.name = data.name;
      state.data.branch = data.branch;
      state.data.code = data.code;
      state.data.corporation = data.corporation;
      state.data.phone = data.phone;
      state.data.office_phone = data.office_phone;
      state.data.address = data.address;
      state.data.road = data.road;
      state.data.district_code = data.district_code
        ? data.district_code
        : "เลือกเขต/อำเภอ";
      state.data.districts_name = data.districts_name
        ? data.districts_name
        : "เลือกเขต/อำเภอ";
      state.data.sub_district_code = data.sub_district_code
        ? data.sub_district_code
        : "เลือกแขวง/ตำบล";
      state.data.sub_districts_name = data.sub_districts_name
        ? data.sub_districts_name
        : "เลือกแขวง/ตำบล";
      state.data.province_code = data.province_code
        ? data.province_code
        : "เลือกจังหวัด";
      state.data.province_name = data.province_name
        ? data.province_name
        : "เลือกจังหวัด";
      state.data.postal_code = data.postal_code;
      state.data.email = data.email;
      state.data.fax = data.fax;
      state.data.line_id = data.line_id;
      state.data.note = data.note;
      state.data.contact_types = data.contact_types.map(
        (contact) => contact.type_name
      );
      state.data.contact_types_detail = data.contact_types;
      state.data.tax_id = data.tax_id;
      state.data.direction_info = data.direction_info;
      state.data.billing_name = data.billing_name;
      state.data.credit_type_id = data.credit_type_id;
      state.data.customer_type_id = data.customer_type_id;
      state.data.urgency_hospital_type_id = data.urgency_hospital_type_id;
      state.data.credit_type = data.credit_type;
      state.data.customer_type = data.customer_type;
      state.data.urgency_hospital_type = data.urgency_hospital_type;
      state.data.corporation_id = data.corporation_id;
      state.data.addresses = data.addresses;
      state.data.phones = data.phones;
      state.data.lineIds = data.lineIds;
      state.data.faxs = data.faxs;
      state.data.emails = data.emails;
      state.data.created_at = data.created_at;
      state.data.created_by = data.created_by;
      state.data.updated_by = data.updated_by;
      state.data.updated_at = data.updated_at;
      // state.data.animals = data.animals
    },
    RESET_DATA(state, data) {
      (state.data.id = data.id),
        (state.data.name = data.name),
        (state.data.branch = data.branch),
        (state.data.code = data.code),
        (state.data.phone = data.phone),
        (state.data.office_phone = data.office_phone),
        (state.data.address = data.address),
        (state.data.road = data.road),
        (state.data.corporation = data.corporation)(
          (state.data.district_code = data.district_code
            ? data.district_code
            : "เลือกเขต/อำเภอ")
        ),
        (state.data.districts_name = data.districts_name
          ? data.districts_name
          : "เลือกเขต/อำเภอ"),
        (state.data.sub_district_code = data.sub_district_code
          ? data.sub_district_code
          : "เลือกแขวง/ตำบล"),
        (state.data.sub_districts_name = data.sub_districts_name
          ? data.sub_districts_name
          : "เลือกแขวง/ตำบล"),
        (state.data.province_code = data.province_code
          ? data.province_code
          : "เลือกจังหวัด"),
        (state.data.province_name = data.province_name
          ? data.province_name
          : "เลือกจังหวัด"),
        (state.data.postal_code = data.postal_code),
        (state.data.email = data.email),
        (state.data.fax = data.fax),
        (state.data.line_id = data.line_id),
        (state.data.note = data.note),
        (state.data.contact_types = data.contact_types),
        (state.data.contact_types_detail = data.contact_types_detail),
        (state.data.tax_id = data.tax_id),
        (state.data.direction_info = data.direction_info),
        (state.data.billing_name = data.billing_name),
        (state.data.credit_type_id = data.credit_type_id),
        (state.data.customer_type_id = data.customer_type_id),
        (state.data.urgency_hospital_type_id = data.urgency_hospital_type_id),
        (state.data.credit_type = data.credit_type),
        (state.data.customer_type = data.customer_type),
        (state.data.urgency_hospital_type = data.urgency_hospital_type),
        // (state.data.corporation_id = data.corporation_id),
        (state.data.addresses = data.addresses),
        (state.data.phones = data.phones),
        (state.data.lineIds = data.lineIds),
        (state.data.faxs = data.faxs),
        (state.data.emails = data.emails);
      state.data.created_at = data.created_at;
      state.data.created_by = data.created_by;
      state.data.updated_by = data.updated_by;
      state.data.updated_at = data.updated_at;
      // (state.data.animals = data.animals)
    },
    SET_MESSAGE(state, message) {
      state.message = message;
    },
    SET_FILTER(state, filter) {
      state.filters = filter;
    },
    REMOVE_CUSTOMER_ID(state) {
      state.data.id = "";
    },
  },
  actions: {
    removeCustomerId: (context) => {
      context.commit("REMOVE_CUSTOMER_ID");
    },
    setFilter: (context, filter) => {
      context.commit("SET_FILTER", filter);
    },
    getAll: (context) => {
      Service.hospital.getAllHospitals().then((res) => {
        context.commit("GET_ALL_HOSPITALS", res);
      });
    },
    filterData: async (context, payload) => {
      let res = await Service.hospital.filterHospitals(payload);

      context.commit("FILTER_HOSPITALS", res);
    },
    setData(context, id) {
      if (id) {
        return Service.hospital.getHospital(id).then((res) => {
          context.commit("SET_DATA", res);
        });
      } else {
        const data = {
          hospital_id: null,
          id: "",
          name: "",
          branch: "",
          code: "",
          phone: "",
          office_phone: "",
          address: "",
          corporation: null,
          road: "",
          district_code: "Select district",
          districts_name: "Select district",
          sub_district_code: "Select sub-district",
          sub_districts_name: "Select sub-district",
          province_code: "Select province",
          province_name: "Select province",
          postal_code: "",
          email: "",
          fax: "",
          line_id: "",
          note: "",
          contact_types: [],
          contact_types_detail: [],
          tax_id: "",
          direction_info: [],
          billing_name: "",
          credit_type_id: "",
          customer_type_id: "",
          urgency_hospital_type_id: "",
          // corporation_id: [],
          addresses: [],
          phones: [],
          lineIds: [],
          faxs: [],
          emails: [],
          created_by: null,
          updated_by: null,
          created_at: null,
          // animals: []
        };
        return Service.hospital.genCodeHospital().then((res) => {
          // data.code = "00" + res;
          context.commit("SET_DATA", data);
        });
      }
    },
    updateData: async (context, payload) => {
      if (payload.id != "") {
        if (payload.district_code == "Select district") {
          payload.district_code = "";
        }
        if (payload.sub_district_code == "Select sub-district") {
          payload.sub_district_code = "";
        }
        if (payload.province_code == "Select province") {
          payload.province_code = "";
        }
        let setData = await Service.hospital.updateHospital(
          payload.id,
          payload
        );
        context.commit("SET_DATA", setData);
        // let getData = await Service.hospital.getAllHospitals();
        // context.commit("GET_ALL_HOSPITALS", getData);
      } else {
        if (payload.district_code == "Select district") {
          payload.district_code = "";
        }
        if (payload.sub_district_code == "Select sub-district") {
          payload.sub_district_code = "";
        }
        if (payload.province_code == "Select province") {
          payload.province_code = "";
        }
        let setData = await Service.hospital.saveHospital(payload);
        context.commit("SET_LATEST_CREATED_ID", setData.id);
        context.commit("SET_DATA", setData);

        // let getData = await Service.hospital.getAllHospitals();
        // context.commit("GET_ALL_HOSPITALS", getData);
      }
    },
    setMessage({ commit }, message) {
      commit("SET_MESSAGE", message);
    },
    resetData({ commit }) {
      const data = {
        id: "",
        name: "",
        branch: "",
        code: "",
        phone: "",
        office_phone: "",
        address: "",
        road: "",
        district_code: "เลือกเขต/อำเภอ",
        districts_name: "เลือกเขต/อำเภอ",
        sub_district_code: "เลือกแขวง/ตำบล",
        sub_districts_name: "เลือกแขวง/ตำบล",
        province_code: "เลือกจังหวัด",
        province_name: "เลือกจังหวัด",
        postal_code: "",
        email: "",
        fax: "",
        line_id: "",
        note: "",
        contact_types: [],
        contact_types_detail: [],
        tax_id: "",
        direction_info: [],
        corporation: null,
        billing_name: "",
        credit_type_id: "",
        customer_type_id: "",
        urgency_hospital_type_id: "",
        // corporation_id: [],
        addresses: [],
        phones: [],
        lineIds: [],
        faxs: [],
        emails: [],
        created_by: null,
        updated_by: null,
        created_at: null,
        // animals: []
      };
      commit("RESET_DATA", data);
    },
    searchHospitalName: async ({ commit }, payload) => {
      return await Service.hospital.searchHospitalName(payload);
    },
    getContactTypes: async ({ commit }, id) => {
      return await Service.hospital.getContactTypes(id);
    },
    searchHospital({ commit }, payload) {
      return Service.hospital.filterHospitals(payload);
    },
    deleteHospital: async ({ commit }, data) => {
      let confirmPassword = await Service.auth.confirmPassword(data.payload);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.hospital.deleteHospital(data.id, token);
      } else {
        return false;
      }
    },
    genCodeHospital: async ({ commit }, directionId) => {
      return await Service.hospital.genCodeHospital(directionId);
    },
  },
  getters: {
    getLatestCreatedId(state) {
      return state.latestCreatedId;
    },
    getAll(state) {
      return state.list;
    },
    getMessage(state) {
      return state.message;
    },
    getData(state) {
      return state.data;
    },
    getDataFromFilter(state) {
      return state.filter;
    },
    getFilter(state) {
      return state.filters;
    },
  },
};

export default hospitalModule;
